import { BarChart, Bar, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from 'recharts';


const BarChartParachute = ({data, xLabel, yLabel, yDisplay}) => {

return (
    <ResponsiveContainer width="100%" height={300}>
    <BarChart 
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
    >
        <CartesianGrid 
        strokeDasharray="3 3" 
        stroke="#f1f5f9" 
        vertical={false}
        />
        <XAxis 
        dataKey={xLabel} 
        axisLine={false}
        tickLine={false}
        tick={{ fontSize: 12, fill: '#64748b', fontWeight: '500' }}
        />
        <YAxis 
        axisLine={false}
        tickLine={false}
        tick={{ fontSize: 12, fill: '#64748b', fontWeight: '500' }}
        />
        <Tooltip 
        contentStyle={{
            backgroundColor: '#1e293b',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        }}
        labelStyle={{ color: '#f1f5f9', fontWeight: '600' }}
        />
        <Legend 
        wrapperStyle={{ paddingTop: '20px' }}
        />
        <Bar 
            dataKey={yLabel} 
            fill="#059669"
            radius={[4, 4, 0, 0]}
            name={yDisplay}
        />
    </BarChart>
    </ResponsiveContainer>
);
}
export default BarChartParachute;